import type { StorePersistConfig } from "~/@types/store";
import type { ThemeOptions, ThemeState } from "~/@types/store/theme";

export const useThemeStore = defineStore({
  id: 'theme-store',
  state: (): ThemeState => ({
    current: 'light',
    default: 'light',
  }),
  persist: {
    storage: persistedState.localStorage,
    paths: ['current'],
  } as StorePersistConfig,
  actions: {
    init(): void {
      document.documentElement.setAttribute('data-theme', this.current);
    },
    toggle(): void {
      this.current = this.current === 'light' ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', this.current);

      document.body.classList.add('no-transition');
      setTimeout(() => document.body.classList.remove('no-transition'), 300);
    },
    setTheme(theme: ThemeOptions): void {
      this.current = theme;
      document.documentElement.setAttribute('data-theme', theme);
    },
  },
})
